export const ALL_MONTHS = 'all'

export const monthLabel = (monthKey) => {
  if (!monthKey) return ''
  const [year, month] = String(monthKey).split('-')
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, 1))
  if (Number.isNaN(date.getTime())) return monthKey
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date)
}

export const shortMonthLabel = (monthKey) => {
  if (!monthKey) return ''
  const [year, month] = String(monthKey).split('-')
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, 1))
  if (Number.isNaN(date.getTime())) return monthKey
  const monthName = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    timeZone: 'UTC',
  }).format(date)
  return `${monthName} '${String(year).slice(-2)}`
}

const emptyTotals = {
  collected: 0,
  owed: 0,
  total: 0,
  teamCount: 0,
}

export const getViewTotals = (report, selectedMonth = ALL_MONTHS) => {
  if (!report?.teams?.length) return emptyTotals

  if (selectedMonth === ALL_MONTHS) {
    return {
      collected: Number(report.totals?.collected || 0),
      owed: Number(report.totals?.owed || 0),
      total: Number(report.totals?.total || 0),
      teamCount: report.teams.length,
    }
  }

  const month = report.totals?.months?.[selectedMonth] || emptyTotals
  const teamCount = report.teams.filter(
    (team) => Number(team.months?.[selectedMonth]?.total || 0) > 0
  ).length

  return {
    collected: Number(month.collected || 0),
    owed: Number(month.owed || 0),
    total: Number(month.total || 0),
    teamCount,
  }
}

export const getTeamRows = (report, selectedMonth = ALL_MONTHS) => {
  if (!report?.teams?.length) return []

  return report.teams
    .map((team) => {
      const source =
        selectedMonth === ALL_MONTHS
          ? team
          : team.months?.[selectedMonth] || emptyTotals
      const collected = Number(source.collected || 0)
      const owed = Number(source.owed || 0)
      const total = Number(source.total || collected + owed)
      const percentCollected = total > 0 ? (collected / total) * 100 : 0
      return {
        organizationUUID: team.organizationUUID,
        organizationName: team.organizationName,
        collected,
        owed,
        total,
        percentCollected,
      }
    })
    .filter((row) => selectedMonth === ALL_MONTHS || row.total > 0)
    .sort((a, b) => b.total - a.total)
}

export const getActiveMonths = (report) =>
  (report?.months || []).filter(
    (monthKey) => Number(report.totals?.months?.[monthKey]?.total || 0) > 0
  )

export const getMonthSeries = (report) => {
  const months = getActiveMonths(report)
  return {
    categories: months.map((monthKey) => shortMonthLabel(monthKey)),
    collected: months.map((monthKey) =>
      Number(report.totals?.months?.[monthKey]?.collected || 0)
    ),
    owed: months.map((monthKey) =>
      Number(report.totals?.months?.[monthKey]?.owed || 0)
    ),
    totals: months.map((monthKey) =>
      Number(report.totals?.months?.[monthKey]?.total || 0)
    ),
  }
}

export const percentOfTotal = (value, total) =>
  total > 0 ? Math.round((Number(value || 0) / total) * 100) : 0
